module.exports = __webpack_public_path__ + "807a0c884cedb9b3504e67bc0c3f0d73.MP3";